// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"FaqSearchForm_searchIcon__rqTlu"};